import React from 'react';
import { Navigate } from 'react-router-dom';
import { ClientsView } from '@/components/views/ClientsView';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import AnnouncementBanner from '@/components/layouts/AnnouncementBanner';
import { paths } from '@/app/paths';
import { useAdminModeAccess } from '@/hooks/useAdminModeAccess';

export const HomePage = () => {
	const { canAccessAdminMode, isAdminModeAccessLoading, hasBrokerGroups } = useAdminModeAccess();

	if (!isAdminModeAccessLoading && canAccessAdminMode && !hasBrokerGroups) {
		return <Navigate to={paths.adminUsers} replace />;
	}

	return (
		<AuthenticatedPageLayout>
			<AnnouncementBanner />
			<ClientsView />
		</AuthenticatedPageLayout>
	);
};
